import { defineAction } from '~/prix'
import citizenHealthProfileFetchByHashAction from './citizenHealthProfileFetchByHash.action.json' with { type: 'json' }
import { z } from 'zod'

const citizenHealthProfileFetchByHashDefinition = defineAction({
  ...citizenHealthProfileFetchByHashAction,

  input: z.object({
    hash: z.string(),
  }),
  output: z.object({
    items: z.array(z.any()),
  }),
})

export default citizenHealthProfileFetchByHashDefinition
